import { ONBOARDING_FORM_STYLES } from "@/features/onboarding/components/onboarding-form-styles";

export function OnboardingStepHeader({
  title,
  description,
  eyebrow = "Your provider account",
}: {
  title: string;
  description?: string;
  eyebrow?: string;
}) {
  return (
    <header className={ONBOARDING_FORM_STYLES.header}>
      <p className={ONBOARDING_FORM_STYLES.eyebrow}>{eyebrow}</p>
      <h2 className={ONBOARDING_FORM_STYLES.title}>{title}</h2>
      {description && (
        <p className={ONBOARDING_FORM_STYLES.description}>{description}</p>
      )}
    </header>
  );
}
